import PropTypes from 'prop-types'

export const reservationProps = {
  id: PropTypes.number.isRequired,
  token: PropTypes.string.isRequired,
  isPurchased: PropTypes.bool,
}
